import { ETariffAbbr, Widgets } from '@common/enums';

const freeElements: Widgets[] = [
    Widgets.BUTTON,
    Widgets.IMAGE,
    Widgets.GALLERY,
    Widgets.LINE,
    Widgets.INDENT,
    Widgets.TEXT,
    Widgets.VIDEO,
    Widgets.FORM,
    Widgets.CHAT_BOTS,
    Widgets.SOCIAL_NETWORKS,
    Widgets.MENU,
    Widgets.MAP,
    Widgets.LOGIN_EDU,
    Widgets.EDU_LOGIN_BUTTON,
    Widgets.TESTIMONIAL,
    Widgets.NAVIGATION,
    Widgets.LOGO,
    Widgets.BEFORE_AFTER,
    Widgets.FIGURE,
    Widgets.PRODUCT_CARD,
    Widgets.ACCORDION,
    Widgets.TIMER,
    Widgets.SHOP_CART,
    Widgets.SHOP_CART_ICON,
    Widgets.CATALOG_PRODUCTS,
];

const standardElements: Widgets[] = [...freeElements, Widgets.PAYMENT_FORM, Widgets.CODE];
const proElements: Widgets[] = [...standardElements];
const enterpriseElements: Widgets[] = [...proElements];

const standard2023: Widgets[] = [...proElements];
const pro2023: Widgets[] = [...standard2023];
const enterprise2023: Widgets[] = [...pro2023];

export const currentTariffSetIndex = 1;

export const EDU_FREE_TARIFF = 'education_free';

export const tariffElementsMap: Record<number, Partial<Record<ETariffAbbr, Widgets[]>>> = {
    0: {
        [ETariffAbbr.FREE]: freeElements,
        [ETariffAbbr.STANDARD]: standardElements,
        [ETariffAbbr.PRO]: proElements,
        [ETariffAbbr.ENTERPRISE]: enterpriseElements,
    },
    1: {
        [ETariffAbbr.FREE]: freeElements,
        [ETariffAbbr.STANDARD_2023]: standard2023,
        [ETariffAbbr.PRO_2023]: pro2023,
        [ETariffAbbr.ENTERPRISE_2023]: enterprise2023,
    },
};

export const tariffsCssClasses: Record<ETariffAbbr, string> = {
    [ETariffAbbr.FREE]: '',
    [ETariffAbbr.STANDARD]: 'plan-standard',
    [ETariffAbbr.PRO]: 'plan-pro',
    [ETariffAbbr.ENTERPRISE]: 'plan-enterprise',
    [ETariffAbbr.STANDARD_2023]: 'plan-standard',
    [ETariffAbbr.PRO_2023]: 'plan-pro',
    [ETariffAbbr.ENTERPRISE_2023]: 'plan-enterprise',
};

export const tariffsValue = {
    [ETariffAbbr.FREE]: 0,
    [ETariffAbbr.STANDARD]: 1,
    [ETariffAbbr.PRO]: 2,
    [ETariffAbbr.ENTERPRISE]: 3,
    [ETariffAbbr.STANDARD_2023]: 4,
    [ETariffAbbr.PRO_2023]: 5,
    [ETariffAbbr.ENTERPRISE_2023]: 6,
};
